function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var $50d5d6a623389320$exports = require("./utils.main.js");
var $9LYIl$internationalizeddate = require("@internationalized/date");
var $9LYIl$reactstatelyform = require("@react-stately/form");
var $9LYIl$reactstatelyoverlays = require("@react-stately/overlays");
var $9LYIl$reactstatelyutils = require("@react-stately/utils");
var $9LYIl$react = require("react");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
$parcel$export(module.exports, "useDateRangePickerState", function () {
  return $7072d26f58deb33b$export$e50a61c1de9f574;
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $7072d26f58deb33b$export$e50a61c1de9f574(props) {
  var _value_start, _value_end;
  var overlayState = (0, $9LYIl$reactstatelyoverlays.useOverlayTriggerState)(props);
  var _ref = (0, $9LYIl$reactstatelyutils.useControlledState)(props.value, props.defaultValue || null, props.onChange),
    _ref2 = _slicedToArray(_ref, 2),
    controlledValue = _ref2[0],
    setControlledValue = _ref2[1];
  var _ref3 = (0, $9LYIl$react.useState)(function () {
      return controlledValue || {
        start: null,
        end: null
      };
    }),
    _ref4 = _slicedToArray(_ref3, 2),
    placeholderValue = _ref4[0],
    setPlaceholderValue = _ref4[1];
  // Reset the placeholder if the value prop is set to null.
  if (controlledValue == null && placeholderValue.start && placeholderValue.end) {
    placeholderValue = {
      start: null,
      end: null
    };
    setPlaceholderValue(placeholderValue);
  }
  var value = controlledValue || placeholderValue;
  var setValue = function setValue(value) {
    setPlaceholderValue(value || {
      start: null,
      end: null
    });
    if ($7072d26f58deb33b$var$isCompleteRange(value)) setControlledValue(value);else setControlledValue(null);
  };
  var v = (value === null || value === void 0 ? void 0 : value.start) || (value === null || value === void 0 ? void 0 : value.end) || props.placeholderValue || null;
  var _ref5 = (0, $50d5d6a623389320$exports.useDefaultProps)(v, props.granularity),
    _ref6 = _slicedToArray(_ref5, 2),
    granularity = _ref6[0],
    defaultTimeZone = _ref6[1];
  var hasTime = granularity === 'hour' || granularity === 'minute' || granularity === 'second';
  var _props_shouldCloseOnSelect;
  var shouldCloseOnSelect = (_props_shouldCloseOnSelect = props.shouldCloseOnSelect) !== null && _props_shouldCloseOnSelect !== void 0 ? _props_shouldCloseOnSelect : true;
  var _ref7 = (0, $9LYIl$react.useState)(null),
    _ref8 = _slicedToArray(_ref7, 2),
    dateRange = _ref8[0],
    setSelectedDateRange = _ref8[1];
  var _ref9 = (0, $9LYIl$react.useState)(null),
    _ref10 = _slicedToArray(_ref9, 2),
    timeRange = _ref10[0],
    setSelectedTimeRange = _ref10[1];
  if (value && $7072d26f58deb33b$var$isCompleteRange(value)) {
    dateRange = value;
    if ('hour' in value.start) timeRange = value;
  }
  var commitValue = function commitValue(dateRange, timeRange) {
    setValue({
      start: 'timeZone' in timeRange.start ? timeRange.start.set((0, $9LYIl$internationalizeddate.toCalendarDate)(dateRange.start)) : (0, $9LYIl$internationalizeddate.toCalendarDateTime)(dateRange.start, timeRange.start),
      end: 'timeZone' in timeRange.end ? timeRange.end.set((0, $9LYIl$internationalizeddate.toCalendarDate)(dateRange.end)) : (0, $9LYIl$internationalizeddate.toCalendarDateTime)(dateRange.end, timeRange.end)
    });
    setSelectedDateRange(null);
    setSelectedTimeRange(null);
    validation.commitValidation();
  };
  // Intercept setValue to make sure the Time section is not changed by date selection in Calendar
  var setDateRange = function setDateRange(range) {
    var shouldClose = typeof shouldCloseOnSelect === 'function' ? shouldCloseOnSelect() : shouldCloseOnSelect;
    if (hasTime) {
      if ($7072d26f58deb33b$var$isCompleteRange(range) && (timeRange === null || timeRange === void 0 ? void 0 : timeRange.start) && (timeRange === null || timeRange === void 0 ? void 0 : timeRange.end)) commitValue(range, {
        start: (timeRange === null || timeRange === void 0 ? void 0 : timeRange.start) || (0, $50d5d6a623389320$exports.getPlaceholderTime)(props.placeholderValue),
        end: (timeRange === null || timeRange === void 0 ? void 0 : timeRange.end) || (0, $50d5d6a623389320$exports.getPlaceholderTime)(props.placeholderValue)
      });else setSelectedDateRange(range);
    } else if ($7072d26f58deb33b$var$isCompleteRange(range)) {
      setValue(range);
      validation.commitValidation();
    } else setSelectedDateRange(range);
    if (shouldClose) overlayState.setOpen(false);
  };
  var setTimeRange = function setTimeRange(range) {
    if ($7072d26f58deb33b$var$isCompleteRange(dateRange) && $7072d26f58deb33b$var$isCompleteRange(range)) commitValue(dateRange, range);else setSelectedTimeRange(range);
  };
  var showEra = (value === null || value === void 0 ? void 0 : (_value_start = value.start) === null || _value_start === void 0 ? void 0 : _value_start.calendar.identifier) === 'gregory' && value.start.era === 'BC' || (value === null || value === void 0 ? void 0 : (_value_end = value.end) === null || _value_end === void 0 ? void 0 : _value_end.calendar.identifier) === 'gregory' && value.end.era === 'BC';
  var formatOpts = (0, $9LYIl$react.useMemo)(function () {
    return {
      granularity: granularity,
      timeZone: defaultTimeZone,
      hideTimeZone: props.hideTimeZone,
      hourCycle: props.hourCycle,
      shouldForceLeadingZeros: props.shouldForceLeadingZeros,
      showEra: showEra
    };
  }, [granularity, props.hourCycle, props.shouldForceLeadingZeros, defaultTimeZone, props.hideTimeZone, showEra]);
  var minValue = props.minValue,
    maxValue = props.maxValue,
    isDateUnavailable = props.isDateUnavailable;
  var builtinValidation = (0, $9LYIl$react.useMemo)(function () {
    return (0, $50d5d6a623389320$exports.getRangeValidationResult)(value, minValue, maxValue, isDateUnavailable, formatOpts);
  }, [value, minValue, maxValue, isDateUnavailable, formatOpts]);
  var validation = (0, $9LYIl$reactstatelyform.useFormValidationState)(_objectSpread(_objectSpread({}, props), {}, {
    value: controlledValue,
    name: (0, $9LYIl$react.useMemo)(function () {
      return [props.startName, props.endName].filter(function (n) {
        return n != null;
      });
    }, [props.startName, props.endName]),
    builtinValidation: builtinValidation
  }));
  var isValueInvalid = validation.displayValidation.isInvalid;
  var validationState = props.validationState || (isValueInvalid ? 'invalid' : null);
  return _objectSpread(_objectSpread(_objectSpread({}, validation), {}, {
    value: value,
    setValue: setValue,
    dateRange: dateRange,
    timeRange: timeRange,
    granularity: granularity,
    hasTime: hasTime,
    setDate: function setDate(part, date) {
      var _dateRange_end, _dateRange_start;
      if (part === 'start') setDateRange({
        start: date,
        end: (_dateRange_end = dateRange === null || dateRange === void 0 ? void 0 : dateRange.end) !== null && _dateRange_end !== void 0 ? _dateRange_end : null
      });else setDateRange({
        start: (_dateRange_start = dateRange === null || dateRange === void 0 ? void 0 : dateRange.start) !== null && _dateRange_start !== void 0 ? _dateRange_start : null,
        end: date
      });
    },
    setTime: function setTime(part, time) {
      var _timeRange_end, _timeRange_start;
      if (part === 'start') setTimeRange({
        start: time,
        end: (_timeRange_end = timeRange === null || timeRange === void 0 ? void 0 : timeRange.end) !== null && _timeRange_end !== void 0 ? _timeRange_end : null
      });else setTimeRange({
        start: (_timeRange_start = timeRange === null || timeRange === void 0 ? void 0 : timeRange.start) !== null && _timeRange_start !== void 0 ? _timeRange_start : null,
        end: time
      });
    },
    setDateTime: function setDateTime(part, dateTime) {
      var _value_end, _value_start;
      if (part === 'start') setValue({
        start: dateTime,
        end: (_value_end = value === null || value === void 0 ? void 0 : value.end) !== null && _value_end !== void 0 ? _value_end : null
      });else setValue({
        start: (_value_start = value === null || value === void 0 ? void 0 : value.start) !== null && _value_start !== void 0 ? _value_start : null,
        end: dateTime
      });
    },
    setDateRange: setDateRange,
    setTimeRange: setTimeRange
  }, overlayState), {}, {
    setOpen: function setOpen(isOpen) {
      // Commit the selected date range when the calendar is closed. Use a placeholder time if one wasn't set.
      // If only the time range was set and not the date range, don't commit. The state will be preserved until
      // the user opens the popover again.
      if (!isOpen && !((value === null || value === void 0 ? void 0 : value.start) && (value === null || value === void 0 ? void 0 : value.end)) && $7072d26f58deb33b$var$isCompleteRange(dateRange) && hasTime) commitValue(dateRange, {
        start: (timeRange === null || timeRange === void 0 ? void 0 : timeRange.start) || (0, $50d5d6a623389320$exports.getPlaceholderTime)(props.placeholderValue),
        end: (timeRange === null || timeRange === void 0 ? void 0 : timeRange.end) || (0, $50d5d6a623389320$exports.getPlaceholderTime)(props.placeholderValue)
      });
      overlayState.setOpen(isOpen);
    },
    validationState: validationState,
    isInvalid: isValueInvalid,
    formatValue: function formatValue(locale, fieldOptions) {
      if (!value || !value.start || !value.end) return null;
      var startTimeZone = 'timeZone' in value.start ? value.start.timeZone : undefined;
      var startGranularity = props.granularity || (value.start && 'minute' in value.start ? 'minute' : 'day');
      var endTimeZone = 'timeZone' in value.end ? value.end.timeZone : undefined;
      var endGranularity = props.granularity || (value.end && 'minute' in value.end ? 'minute' : 'day');
      var startOptions = (0, $50d5d6a623389320$exports.getFormatOptions)(fieldOptions, {
        granularity: startGranularity,
        timeZone: startTimeZone,
        hideTimeZone: props.hideTimeZone,
        hourCycle: props.hourCycle,
        showEra: value.start.calendar.identifier === 'gregory' && value.start.era === 'BC' || value.end.calendar.identifier === 'gregory' && value.end.era === 'BC'
      });
      var startDate = value.start.toDate(startTimeZone || 'UTC');
      var endDate = value.end.toDate(endTimeZone || 'UTC');
      var startFormatter = new (0, $9LYIl$internationalizeddate.DateFormatter)(locale, startOptions);
      var endFormatter;
      if (startTimeZone === endTimeZone && startGranularity === endGranularity && value.start.compare(value.end) !== 0) {
        // Use formatRange, as it results in shorter output when some of the fields
        // are shared between the start and end dates (e.g. the same month).
        // Formatting will fail if the end date is before the start date. Fall back below when that happens.
        try {
          var parts = startFormatter.formatRangeToParts(startDate, endDate);
          // Find the separator between the start and end date. This is determined
          // by finding the last shared literal before the end range.
          var separatorIndex = -1;
          for (var i = 0; i < parts.length; i++) {
            var part = parts[i];
            if (part.source === 'shared' && part.type === 'literal') separatorIndex = i;else if (part.source === 'endRange') break;
          }
          // Now we can combine the parts into start and end strings.
          var start = '';
          var end = '';
          for (var _i = 0; _i < parts.length; _i++) {
            if (_i < separatorIndex) start += parts[_i].value;else if (_i > separatorIndex) end += parts[_i].value;
          }
          return {
            start: start,
            end: end
          };
        } catch (_unused) {
          // ignore
        }
        endFormatter = startFormatter;
      } else {
        var endOptions = (0, $50d5d6a623389320$exports.getFormatOptions)(fieldOptions, {
          granularity: endGranularity,
          timeZone: endTimeZone,
          hideTimeZone: props.hideTimeZone,
          hourCycle: props.hourCycle
        });
        endFormatter = new (0, $9LYIl$internationalizeddate.DateFormatter)(locale, endOptions);
      }
      return {
        start: startFormatter.format(startDate),
        end: endFormatter.format(endDate)
      };
    },
    getDateFormatter: function getDateFormatter(locale, formatOptions) {
      var newOptions = _objectSpread(_objectSpread({}, formatOpts), formatOptions);
      var newFormatOptions = (0, $50d5d6a623389320$exports.getFormatOptions)({}, newOptions);
      return new (0, $9LYIl$internationalizeddate.DateFormatter)(locale, newFormatOptions);
    }
  });
}
function $7072d26f58deb33b$var$isCompleteRange(value) {
  return (value === null || value === void 0 ? void 0 : value.start) != null && value.end != null;
}